module.exports = __webpack_public_path__ + "email-31GA1-T.svg";